export interface DataGridVirtualizationInput {
    /** When true, enables both row and column virtualization unless overridden. Default false. */
    useVirtualizedScroll?: boolean;
    /** Row virtualization; falls back to {@link useVirtualizedScroll}. */
    useVirtualizedRows?: boolean;
    /** Column virtualization; falls back to {@link useVirtualizedScroll}. */
    useVirtualizedColumns?: boolean;
}

export interface ResolvedDataGridVirtualization {
    rowsEnabled: boolean;
    columnsEnabled: boolean;
}

/**
 * Resolves row/column virtualization flags.
 * `useVirtualizedScroll` is a convenience master switch (default false); explicit row/column props override it.
 */
export function resolveDataGridVirtualization(input: DataGridVirtualizationInput): ResolvedDataGridVirtualization {
    const master = input.useVirtualizedScroll ?? false;
    return {
        rowsEnabled: input.useVirtualizedRows ?? master,
        columnsEnabled: input.useVirtualizedColumns ?? master,
    };
}

export function isAnyDataGridVirtualizationEnabled(input: DataGridVirtualizationInput): boolean {
    const {rowsEnabled, columnsEnabled} = resolveDataGridVirtualization(input);
    return rowsEnabled || columnsEnabled;
}

/**
 * Row virtualization is only useful when there are more rows than the visible-row cap.
 */
export function shouldVirtualizeDataGridRows(
    rowsEnabled: boolean,
    rowCount: number,
    maxVisibleRows: number,
): boolean {
    return rowsEnabled && rowCount > Math.max(0, maxVisibleRows);
}
